export default function LoaderBilan() {
    return (
        <div className="loader-bilan">
            <div className="loader-bilan-dot"></div>
            <div className="loader-bilan-dot"></div>
            <div className="loader-bilan-dot"></div>
        </div>
    );
};

;
